module.exports = __webpack_public_path__ + "img/mobile_about_hero_img.16c44681.jpg";